import { useState, useEffect } from 'react';
import supabase from '../supabase';

const MAX_FAVORITES = 50;

const useFavorites = (user, lang, onRequireLogin) => {
  const [favorites, setFavorites] = useState([]);
  const [favCities, setFavCities] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ec_fav_cities') || '{}'); } catch { return {}; }
  });

  useEffect(() => {
    if (!user) { setFavorites([]); return; }
    supabase.from('favorites').select('name').eq('user_id', user.id)
      .then(({ data }) => { if (data) setFavorites(data.map(r => r.name)); });
  }, [user]);

  const toggleFav = async (name, city = '') => {
    if (!user) { onRequireLogin?.(); return; }
    const isFav = favorites.includes(name);
    if (isFav) {
      setFavorites(p => p.filter(x => x !== name));
      setFavCities(p => {
        const n = { ...p }; delete n[name];
        try { localStorage.setItem('ec_fav_cities', JSON.stringify(n)); } catch {}
        return n;
      });
      await supabase.from('favorites').delete().eq('user_id', user.id).eq('name', name);
    } else {
      if (favorites.length >= MAX_FAVORITES) {
        alert(lang === 'en' ? `Favourites limit reached (${MAX_FAVORITES})` : `收藏已達上限（${MAX_FAVORITES} 個）`);
        return;
      }
      setFavorites(p => [...p, name]);
      if (city) setFavCities(p => {
        const n = { ...p, [name]: city };
        try { localStorage.setItem('ec_fav_cities', JSON.stringify(n)); } catch {}
        return n;
      });
      await supabase.from('favorites').insert({ user_id: user.id, name });
      supabase.from('attraction_likes').insert({ attraction_name: name, city: city || '', user_id: user.id })
        .then(() => {}).catch(() => {});
    }
  };

  return { favorites, setFavorites, favCities, toggleFav };
};

export default useFavorites;
